module.exports = __webpack_public_path__ + "static/img/vedioimg.70906333.png";